import { useContext } from 'react'
import Image from '../../assets/Rectangle 466 (1).png'
import Logo from '../../assets/ExploreLogo.png'
import { ExploreDataProvider } from '../../store/ExploreData'
import { useNavigate } from 'react-router-dom'
import MetaData from '../../components/MetaData'
export const ExploreIndustries = () => {
    const { Explore } = useContext(ExploreDataProvider)
    const navigate = useNavigate()
    return (
        <>
            <MetaData
                title="Explore Industries & Career Skills | CareerConnect AI"
                description="Discover career paths across various industries and in-demand skills. Explore opportunities from IT to healthcare, finance, and more with CareerConnect AI."
                url="https://www.careerconnectai.com/explore"
                keywords="industries, career skills, job skills, career paths, technology, healthcare, finance, education, careerconnect, careerconnect ai"
            />
            <section className="w-full  min-h-[750px] py-6 md:py-12 px-4 md:px-16 lg:px-24">
                <div className="bg-white w-full h-auto md:h-24 mb-10 rounded-lg flex flex-col md:flex-row items-center justify-between px-3 py-3 md:px-6 shadow">
                    {/* Middle Section - Title */}
                    <div className="flex flex-col items-center text-center mt-2 md:mt-0">
                        <p className="text-base sm:text-lg md:text-xl lg:text-2xl font-semibold">
                            Explore Industries & Skills
                        </p>
                        <p className="text-xs sm:text-sm md:text-base text-gray-600">
                            Discover career paths across domains
                        </p>
                    </div>
                </div>
                {Explore && Explore.length > 0 ? (
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                        {Explore.map((item, idx) => (
                            <div key={idx} className="relative w-full rounded-2xl overflow-hidden shadow-lg">
                                {/* Image */}

                                {/* Image */}
                                <img
                                    src={item.image}
                                    alt={`industry-${idx}`}
                                    className="w-full h-full object-cover"
                                />
                                {/* Bottom overlay */}
                                <div className="absolute bottom-0 left-0 w-full py-2 bg-white/60  flex flex-col items-center justify-center gap-2 pt-3 md:gap-3 md:py-4 px-4 rounded-b-xl">
                                    {/* Skills slider */}
                                    <div className="relative w-full overflow-hidden">
                                        <div className="flex whitespace-nowrap animate-scroll hover:pause-animation gap-5">
                                            {item.skills && item.skills.length > 0 ? (
                                                [...item.skills, ...item.skills].map((skill, i) => (
                                                    <span onClick={() => navigate('/login')}
                                                        key={i}
                                                        className={`bg-white ${i && "hover:text-primary-500 hover:font-semibold"
                                                            } text-black px-3 py-1 rounded-full shadow-sm border border-gray-200`}
                                                    >
                                                        {skill}
                                                    </span>
                                                ))
                                            ) : (
                                                <span className="text-gray-500">No skills found</span>
                                            )}
                                        </div>
                                    </div>

                                    <div onClick={() => navigate('/login')} className="py-2 sm:py-0 flex items-center gap-4 px-4">
                                        <img
                                            src={item.icon}
                                            alt={item.heading}
                                            className="h-8 md:h-10 object-contain aspect-square"
                                        />
                                        <div className="flex flex-col ">
                                            <h2 className="font-medium">{item.heading}</h2>
                                            <p className=" text-[10px] text-sm hidden sm:block">{item.title}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div>No data found</div>
                )}

                <div className="relative w-full">
                    <div className="absolute inset-0">
                        <img
                            src={Image}
                            alt="background"
                            className="w-full h-full object-cover"
                        />
                        <div className="absolute inset-0"></div>
                    </div>
                    <div className="relative flex flex-col items-center bg-transparent bg-gradient-to-r from-[#2C25C4] to-[#8C18C3] w-full px-4 sm:px-8 py-8 mt-10 rounded-2xl z-10">
                        <div className="flex gap-2 sm:gap-3 items-center justify-center mb-6">
                            <div className="flex-shrink-0">
                                <img src={Logo} alt="explore logo" className="h-12 sm:h-24 w-auto" />
                            </div>
                            <div className="sm:items-center gap-2 sm:gap-5 sm:text-left">
                                <h3 className="text-lg sm:text-xl font-semibold text-white">
                                    Your Career, Your Choice
                                </h3>
                                <p className="text-sm sm:text-lg text-white">
                                    Beyond the Listed Categories
                                </p>
                            </div>
                        </div>
                        <p className="text-slate-200 text-sm sm:text-base md:text-lg max-w-6xl text-justify sm:text-left leading-relaxed">
                            The industries and skills listed here are only a starting point—a snapshot of the most in-demand opportunities.
                            But your career is much more than a label or a category. At
                            <span className="font-bold text-white"> CareerConnect AI</span>, we believe talent has no boundaries, and opportunities should not be restricted to predefined boxes.
                            Whether you are an experienced professional in a specialized niche, a fresh graduate exploring your first role, or someone making a bold career shift into a completely new field, this is the space where your journey belongs.
                        </p>
                    </div>
                </div>


            </section>
        </>

    )
}
